import React, { useState } from "react";
import { get } from "lodash";

import { getIcon } from "../../../../helpers/icons";
import { Button } from "../../../../components/Field";
import ChangePlan from "./ChangePlan";
import CancelMembership from "./CancelMembership";
import Title from "../../../../components/Title";
import Spacer from "../../../../components/Spacer";
import DialogBox from "../../../../components/DialogBox";
import RenewMembership from "../../../../components/DialogBox/RenewMembership";

import style from "../style.module.css";

export default function Memberships(props) {
    const {
        userProfile = {},
        planDetailsFromApi = {}
    } = props;
    const [popup, setPopup] = useState(false);
    
    return (
        <>
            <div className={style.cardItem}>
                <div className={style.cardItemHeader}>
                    <Title className="fontTeko" tag="p" transform="uppercase">Plan details</Title>
                </div>
                {
                    userProfile?.membership === null && userProfile.oldMembership?.auto_renewal === 0 && (
                        <>
                            <div className={`${style.toast} ${style.red} ${style.paymentError}`}>
                                <i className={getIcon("Info")}></i>
                                Your current plan is expired, please click below to renew your membership.
                            </div>
                            <div className={style.renewBtn}>
                                <Button
                                    onClick={() => { setPopup("renew") }}
                                    size="buttonFullWidth"
                                    label="RENEW"
                                    color="buttonPrimary"
                                />
                            </div>
                        </>
                    )
                }
                {
                    userProfile?.membership !== null && (
                        <>
                            <Spacer size="24" />
                            <div className={style.cardItemtBody}>
                                <div className={style.cardItemtBodyInner}>
                                    <ChangePlan
                                        userProfile={userProfile}
                                        planDetailsFromApi={planDetailsFromApi}
                                    />
                                    {
                                        get(userProfile, 'membership.is_cancel', 0) !== 1 && (
                                            <CancelMembership />
                                        )
                                    }
                                </div>
                            </div>
                        </>
                    )
                }
            </div>
            <Spacer size="65" />
            {
                popup === "renew" && (
                    <DialogBox
                        onClose={() => setPopup(false)}
                        className={style.articlePopup}
                        title={false}
                        headerClass={style.dialogBoxHeader}
                        modalClassName={style.articleModal}
                        buttonClassName={style.customCloseStyle}
                        hasCloseIcon={false}
                        render={({ closeDialog }) => (
                            <RenewMembership
                                closeDialog={closeDialog}
                                userProfile={userProfile}
                            />
                        )}
                    />
                )
            }
        </>
    )
}